import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setDialogAction,
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { getLoggedInUserThunk } from '@/state/auth/thunk/get-logged-in.thunk'
import { USER } from './api.routes'
import ActionTypes from '../constants'

import { UpdateUserPayload, UserResponse, UserState } from '../models'
import { setCurrentUser } from '../slices/index.slices'

const apiService: RestApiService = Container.get(RestApiService)

export const updateUserThunk = createAsyncThunk(
  ActionTypes.UPDATE_USER,
  async (payload: UpdateUserPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'PUT',
        endpoint: USER.UPDATE,
        body: payload,
      }

      const userSession = sessionStorage.getItem('user')
      let idSession = ''
      if (userSession) {
        idSession = JSON.parse(userSession)._id
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: UserResponse = await apiService.updateAuthData(
        auth.token || '',
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('user')} ${payload.username}`,
        what: i18n.t('labels.updated'),
      })

      if (response.username) {
        if (idSession === response.id) {
          sessionStorage.setItem('user', JSON.stringify(response))
        }

        thunkAPI.dispatch(setDialogAction({ open: false }))
        thunkAPI.dispatch(getLoggedInUserThunk())
        thunkAPI.dispatch(setCurrentUser(null))
      } else {
        message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant: response.username ? 'success' : 'error',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))

      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const updateUserExtraReducer = (
  builder: ActionReducerMapBuilder<UserState>,
) => {
  builder.addCase(updateUserThunk.fulfilled, (state, { payload }) => {
    state.users = state.users.map((user) => {
      if (user.id === payload.id) {
        return {
          ...user,
          ...payload,
        }
      }
      return user
    })
  })
}

export default updateUserExtraReducer
